/** In this function we can verify that the translated value is correct or not
 * and return the boolean value
 * @param {*} value translated value
 */
var regex = /[#]/g;

var verifyTranslateValue = function verifyTranslateValue(value) {
  return value && value.match(regex) !== null && value.match(regex).length === 4;
};

export default verifyTranslateValue;